var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRamzanActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 202.948,
    height: 246.734,
    viewBox: "0 0 202.948 246.734",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9387",
    "data-name": "Group 9387",
    transform: "translate(-686.714 -1767.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9385",
    "data-name": "Group 9385",
    transform: "translate(689 1767.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9384",
    "data-name": "Group 9384",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3674",
    "data-name": "Rectangle 3674",
    width: 82.424,
    height: 53.232,
    transform: "translate(3.402 84.664)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40073",
    "data-name": "Path 40073",
    d: "M252.551,385.1H221.135V349.6l15.658-12.136L252.551,349.6Z",
    transform: "translate(-192.227 -247.407)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40074",
    "data-name": "Path 40074",
    d: "M215.54,367.963H199.681V348.214l7.9-6.75,7.955,6.75Z",
    transform: "translate(-191.752 -247.496)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40075",
    "data-name": "Path 40075",
    d: "M274.665,367.963H258.806V348.214l7.9-6.75,7.955,6.75Z",
    transform: "translate(-193.062 -247.496)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40076",
    "data-name": "Path 40076",
    d: "M281.406,327.89l-89.834.2,3.613-5.822h82.607Z",
    transform: "translate(-191.572 -247.071)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40077",
    "data-name": "Path 40077",
    d: "M191.572,390.525l89.834-.2-3.613,5.822H195.186Z",
    transform: "translate(-191.572 -248.578)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40078",
    "data-name": "Path 40078",
    d: "M236.526,263.452c-27.7,31.819-36.436,27.3-41.053,53.8h82.1c-4.617-26.5-13.35-21.981-41.052-53.8",
    transform: "translate(-191.659 -245.768)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40079",
    "data-name": "Path 40079",
    d: "M236.577,453.632c-27.7-31.818-36.436-27.3-41.053-53.8H277.63c-4.617,26.5-13.35,21.981-41.053,53.8",
    transform: "translate(-191.66 -248.789)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1679",
    "data-name": "Line 1679",
    y1: 17.684,
    transform: "translate(44.866 0)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9386",
    "data-name": "Group 9386",
    transform: "translate(797.541 1819.815)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9384-2",
    "data-name": "Group 9384",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3674-2",
    "data-name": "Rectangle 3674",
    width: 82.424,
    height: 53.232,
    transform: "translate(3.402 73.418)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40073-2",
    "data-name": "Path 40073",
    d: "M252.551,385.1H221.135V349.6l15.658-12.136L252.551,349.6Z",
    transform: "translate(-192.227 -258.653)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40074-2",
    "data-name": "Path 40074",
    d: "M215.54,367.963H199.681V348.214l7.9-6.75,7.955,6.75Z",
    transform: "translate(-191.752 -258.742)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40075-2",
    "data-name": "Path 40075",
    d: "M274.665,367.963H258.806V348.214l7.9-6.75,7.955,6.75Z",
    transform: "translate(-193.062 -258.742)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40076-2",
    "data-name": "Path 40076",
    d: "M281.406,327.89l-89.834.2,3.613-5.822h82.607Z",
    transform: "translate(-191.572 -258.317)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40077-2",
    "data-name": "Path 40077",
    d: "M191.572,390.525l89.834-.2-3.613,5.822H195.186Z",
    transform: "translate(-191.572 -259.824)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40078-2",
    "data-name": "Path 40078",
    d: "M236.526,263.452c-27.7,31.819-36.436,27.3-41.053,53.8h82.1c-4.617-26.5-13.35-21.981-41.052-53.8",
    transform: "translate(-191.659 -257.014)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40079-2",
    "data-name": "Path 40079",
    d: "M236.577,453.632c-27.7-31.818-36.436-27.3-41.053-53.8H277.63c-4.617,26.5-13.35,21.981-41.053,53.8",
    transform: "translate(-191.66 -260.035)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1679-2",
    "data-name": "Line 1679",
    y1: 6.439,
    transform: "translate(44.867 0)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRamzanActive);
export default __webpack_public_path__ + "static/media/Ramzan_Active.0190b22652717ac112ec9a3b9b6ec7be.svg";
export { ForwardRef as ReactComponent };